import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { ContainerWide, Container, Title, Subtitle } from "../themes/Blocks";

const ButtonWrapper = styled.div`
  margin-top: ${props => props.theme.margins.lg};
  margin-bottom: 60px;
  a {
    padding: 17px 34px;
    outline: none;
    border: none;
    border-radius: 0;
    background: #c11a2e;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: bold;
    transition: all 0.2s ease-out;
    &:hover {
      background: #b90d22;
    }
  }
`;

const Screenshot = styled.div`
  width: 100%;
  height: 600px;
  background-image: url("/sweet-pumpkins.jpg");
  background-size: cover;
  background-position: top left;
  margin-top: 20px;
  margin-bottom: 40px;
  box-shadow: 0 10px 50px -10px rgba(0, 0, 0, 0.75);
  @media (max-width: ${props => props.theme.screen.mobile}) {
    height: 300px;
  }
`;

const Jumbo = () => (
  <ContainerWide>
    <Title color="white" size="xxl" black>
      Learn React
    </Title>
    <Subtitle color="white" size="nm" margin="sm" thin>
      by building
    </Subtitle>
    <Subtitle color="white" size="md" margin="sm" center>
      an app to help you find the best movie to watch.
    </Subtitle>

    <Screenshot />

    <Subtitle color="white" size="nm" center>
      This course is NOT optimised for mobile devices.
    </Subtitle>

    <ButtonWrapper>
      <Link to="/tutorial">Start</Link>
    </ButtonWrapper>
  </ContainerWide>
);

export default Jumbo;



// WEBPACK FOOTER //
// ./src/welcome-page/Jumbo.js